import { copyToArray2j022khrow2yi as copyToArray } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  intercepted2ogpsikxxj4u0 as intercepted,
} from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  CancelHandler3ic7xysezxbm5 as CancelHandler,
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
} from './CancellableContinuationImpl.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { JobNode2tu3g3s3xsko1 as JobNode } from './JobSupport.mjs';
import {
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
} from '../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  Companion_instance2oawqq9qiaris as Companion_instance,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
} from '../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { invokeOnCompletion3npqdfp2wzhn6 as invokeOnCompletion } from './Job.mjs';
import { invokeOnCancellationb68niwbjdmgy as invokeOnCancellation } from './CancellableContinuation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_awaitAll__ivbqpv(_this__u8e3s4, $completion) {
  var tmp;
  if (_this__u8e3s4.i1()) {
    tmp = emptyList();
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(_this__u8e3s4);
    var tmp_0 = (new (AwaitAll())(tmp$ret$0)).ga4($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  }
  return tmp;
}
function awaitAll(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_awaitAll__ivbqpv.bind(VOID, _this__u8e3s4), $completion);
}
var DisposeHandlersOnCancelClass;
function DisposeHandlersOnCancel() {
  if (DisposeHandlersOnCancelClass === VOID) {
    class $ {
      constructor($outer, nodes) {
        this.ia4_1 = $outer;
        this.ha4_1 = nodes;
      }
      ja4() {
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject = this.ha4_1;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          element.sa4().ta4();
        }
      }
      ua4(cause) {
        this.ja4();
      }
      toString() {
        return 'DisposeHandlersOnCancel[' + toString(this.ha4_1) + ']';
      }
    }
    initMetadataForClass($, 'DisposeHandlersOnCancel', VOID, VOID, [CancelHandler()]);
    DisposeHandlersOnCancelClass = $;
  }
  return DisposeHandlersOnCancelClass;
}
var AwaitAllNodeClass;
function AwaitAllNode() {
  if (AwaitAllNodeClass === VOID) {
    class $ extends JobNode() {
      constructor($outer, continuation, $box) {
        if ($box === VOID)
          $box = {};
        $box.ra4_1 = $outer;
        super($box);
        this.oa4_1 = continuation;
        this.qa4_1 = atomic$ref$1(null);
      }
      sa4() {
        var tmp = this.pa4_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('handle');
        }
      }
      va4(value) {
        this.qa4_1.kotlinx$atomicfu$value = value;
      }
      wa4() {
        return this.qa4_1.kotlinx$atomicfu$value;
      }
      xa4() {
        return false;
      }
      ua4(cause) {
        if (!(cause == null)) {
          var token = this.oa4_1.za4(cause);
          if (!(token == null)) {
            this.oa4_1.aa5(token);
            var tmp0_safe_receiver = this.wa4();
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.ja4();
            }
          }
        } else if (this.ra4_1.fa4_1.atomicfu$decrementAndGet() === 0) {
          var tmp0 = this.oa4_1;
          // Inline function 'kotlin.collections.map' call
          var this_0 = this.ra4_1.ea4_1;
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(this_0.length);
          var inductionVariable = 0;
          var last = this_0.length;
          while (inductionVariable < last) {
            var item = this_0[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            var tmp$ret$0 = item.ya4();
            destination.v(tmp$ret$0);
          }
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var tmp$ret$3 = _Result___init__impl__xyqfz8(destination);
          tmp0.rc(tmp$ret$3);
        }
      }
    }
    initMetadataForClass($, 'AwaitAllNode');
    AwaitAllNodeClass = $;
  }
  return AwaitAllNodeClass;
}
var AwaitAllClass;
function AwaitAll() {
  if (AwaitAllClass === VOID) {
    class $ {
      constructor(deferreds) {
        this.ea4_1 = deferreds;
        this.fa4_1 = atomic$int$1(this.ea4_1.length);
      }
      ga4($completion) {
        var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
        cancellable.ta5();
        var tmp = 0;
        var tmp_0 = this.ea4_1.length;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_1 = Array(tmp_0);
        while (tmp < tmp_0) {
          var tmp_2 = tmp;
          var deferred = this.ea4_1[tmp_2];
          deferred.ca3();
          // Inline function 'kotlin.apply' call
          var this_0 = new (AwaitAllNode())(this, cancellable);
          this_0.pa4_1 = invokeOnCompletion(deferred, VOID, this_0);
          tmp_1[tmp_2] = this_0;
          tmp = tmp + 1 | 0;
        }
        var nodes = tmp_1;
        var disposer = new (DisposeHandlersOnCancel())(this, nodes);
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = nodes.length;
        while (inductionVariable < last) {
          var element = nodes[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          element.va4(disposer);
        }
        if (cancellable.ba3()) {
          disposer.ja4();
        } else {
          invokeOnCancellation(cancellable, disposer);
        }
        return cancellable.ua5();
      }
    }
    initMetadataForClass($, 'AwaitAll', VOID, VOID, VOID, [0]);
    AwaitAllClass = $;
  }
  return AwaitAllClass;
}
//region block: exports
export {
  awaitAll as awaitAll3u8r91uegk3sa,
};
//endregion

//# sourceMappingURL=Await.mjs.map
